import { render, staticRenderFns } from "./SiteRiskDrawer.vue?vue&type=template&id=63b4eab5&"
import script from "./SiteRiskDrawer.vue?vue&type=script&lang=js&"
export * from "./SiteRiskDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports